/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { getMessage } from "./helpers";
import { NoData } from "./NoData";

type Props = {
  children: React.ReactNode;
  hasData: boolean;
  messageComponent?: string | JSX.Element;
  renderNoData?: (message: JSX.Element) => JSX.Element;
};

export function DataDisplayWrapper({
  children,
  hasData,
  messageComponent = "No Data Available",
  renderNoData = () => <NoData message={getMessage(messageComponent)} />,
}: Props) {
  if (hasData === true) {
    return <>{children}</>;
  }

  const message = getMessage(messageComponent);
  return renderNoData(message);
}
